"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
require("../../../../TdWebtoolkitControls/controls/List/List");
const ProdSys_1 = require("../../../../TdWebtoolkitControls/javascript/ProdSys/ProdSys");
const Utilities_1 = require("../../../javascript/Utilities");
require("../../ErrorDialog/ErrorDialog.js");
const MethodServerResponse_1 = require("../../../model/MethodServerResponse");
exports.default = {
    impl(ids, parentId, relId, completedHandler, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                let actionResult = yield ProdSys_1.ProdSysDispatcher.Action(ids, ProdSys_1.ProdSysAction.Open, options);
                if (!actionResult.handled) {
                    let contentTempDownloadableUrl = Utilities_1.synUtil.getWSUrl("ContentTempDownloadable");
                    let contentTempDownloadUrl = Utilities_1.synUtil.getWSUrl("ContentTempDownload");
                    if (Utilities_1.synUtil.useSynerisWorkspace) {
                        Utilities_1.synUtil.openWorkspace("synerisws" + ids[0].split("|")[0] + "://common/checkout/" + ids.join(","));
                        if (completedHandler)
                            completedHandler(false);
                    }
                    else {
                        if (ids.length > 1)
                            Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("webtoolkit.multicheckoutwithoutworkspaceerror", "Checkout without syneris Workspace does not allow multiselect. Please select only one item."));
                        else {
                            let guid = Utilities_1.synUtil.getGUID();
                            let dataobj = {
                                "cefunc.28forceoverwrite": true,
                                "tempPathGUID": guid,
                                "tempPathTarget": "cefunc.28checkoutpath",
                                "fromWeb": true
                            };
                            Utilities_1.synUtil.executeMethod({
                                method: "cefunc.28",
                                ids,
                                parentId,
                                relId,
                                done(checkoutResponseJSON) {
                                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                        let checkoutResponse = yield MethodServerResponse_1.MethodServerResponse.fromJSON(checkoutResponseJSON);
                                        Utilities_1.synUtil.getAJAXData({
                                            url: contentTempDownloadableUrl + guid + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken,
                                            done(data) {
                                                if (data.downloadable)
                                                    $.fileDownload(contentTempDownloadUrl + guid + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken + "&forceAttachment=true");
                                                else
                                                    Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("docnocontent"));
                                            }
                                        });
                                        if (completedHandler)
                                            completedHandler(true, checkoutResponse);
                                    });
                                },
                                additionalData: dataobj
                            });
                        }
                    }
                }
            }
            catch (err) {
                Utilities_1.synUtil.Notifications.error(err, { autoHideAfter: 12000 });
            }
        });
    }
};
